/**
 * Откуда слово и склонение глоссария (сервер: models/stressEntries.ts FormProvenanceDto, StressSourceDto; концепт
 * form-provenance 1.1). by — имя человека, null — неизвестно кто. Поля необязательны: сервер до миграции их не отдаёт.
 */
import { z } from 'zod';

export const formOriginSchema = z.enum(['carried', 'manual', 'dictionary']);

/** Склонение: добавлено из файла загрузки (file) или человеком; stress_set — ударение поставил человек */
export const formProvenanceShape = {
  added: z.object({ file: z.string().nullable(), by: z.string().nullable(), at: z.string() }).nullish(),
  stress_set: z.object({ by: z.string().nullable(), at: z.string() }).nullish(),
};

/** Ударение слова: из файла загрузки или его поставил человек; null — неизвестно */
export const stressSourceSchema = z
  .discriminatedUnion('kind', [
    z.object({ kind: z.literal('file'), file: z.string(), by: z.string().nullable(), at: z.string().nullable() }),
    z.object({ kind: z.literal('person'), by: z.string().nullable(), at: z.string() }),
  ])
  .nullish();

export type FormOrigin = z.infer<typeof formOriginSchema>;
export type FormAdded = NonNullable<z.infer<typeof formProvenanceShape.added>>;
export type StressSet = NonNullable<z.infer<typeof formProvenanceShape.stress_set>>;
export type StressSource = z.infer<typeof stressSourceSchema>;
